import {
  Box,
  Button,
  Card,
  CardContent,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import {
  commonTableHeaderIcon,
  KeywordOverviewResultCardsCss,
  KeywordOverviewTableCss
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import { BackLinkAllCss, BackLinkInfoCSS } from './BackLinkCss';
import { CompetitorAnalysisResultCardsTexts } from 'src/common/config/TextMessage';
import HelpIcon from '@mui/icons-material/Help';
import { fifthCardCss } from '../siteAudit/siteAuditCSS';
import { BackLinkAllTexts } from './BackLinkAllTexts';
import { ExpandLess } from '@mui/icons-material';

const StyledTableCell = ({ children, minwidth = '0px' }) => (
  <TableCell>
    <Typography
      variant="body1"
      sx={{
        ...KeywordOverviewTableCss?.tableHeadText
      }}
    >
      {children}
    </Typography>
  </TableCell>
);

export const BackLinkInfo = () => {
  const headers = [
    'Linking Page',
    'DA',
    'Spam Score %',
    'Anchor Text and Target URL',
    'Link Type',
    'First Seen',
    'Lost'
  ];
  return (
    <>

      <Box sx={BackLinkInfoCSS?.mainBox}>
        <Typography sx={BackLinkInfoCSS?.titleSx}>
          {'Enter a URL to see its backlinks'}
        </Typography>
        <Typography sx={BackLinkInfoCSS?.descSx}>
          {
            'Paste a URL to analyze its backlink profile, including Domain Rating, referring pages, and link quality.'
          }
        </Typography>
        <Box
          sx={{
            ...KeywordOverviewResultCardsCss?.mainCardsBox
          }}
        >
          <Box
            sx={{
              ...BackLinkInfoCSS?.bgWhite,
              ...KeywordOverviewResultCardsCss?.subBoxes
            }}
          >
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.domainAuthority}
                </Typography>
                <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
              </Box>
              <Box sx={KeywordOverviewResultCardsCss?.keywordNumBox}>
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {'15'}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              ...BackLinkInfoCSS?.bgWhite,
              ...KeywordOverviewResultCardsCss?.subBoxes
            }}
          >
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.backlinks}
                </Typography>
                <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
              </Box>
              <Box
                sx={{
                  ...KeywordOverviewResultCardsCss?.backLinkBoxSx,
                  ...KeywordOverviewResultCardsCss?.keywordNumBox
                }}
              >
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {'1,123'}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              ...BackLinkInfoCSS?.bgWhite,
              ...KeywordOverviewResultCardsCss?.subBoxes
            }}
          >
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.estimatedOrganicTraffic}
                </Typography>
                <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
              </Box>
              <Box sx={KeywordOverviewResultCardsCss?.keywordNumBox}>
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {'165,000'}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              ...BackLinkInfoCSS?.bgWhite,
              ...KeywordOverviewResultCardsCss?.subBoxes
            }}
          >
            <Box>
              <Box sx={KeywordOverviewResultCardsCss?.subBoxHeader}>
                <Typography sx={KeywordOverviewResultCardsCss?.subHeaderFont}>
                  {CompetitorAnalysisResultCardsTexts?.totalKeywords}
                </Typography>

                <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
              </Box>
              <Box sx={KeywordOverviewResultCardsCss?.keywordNumBox}>
                <Typography sx={KeywordOverviewResultCardsCss?.keywordNum}>
                  {'2,345'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Card
          sx={{
            marginTop: '20px',
            ...fifthCardCss?.card,
            padding: '0px !important'
          }}
          className="scan-data-table"
        >
          <CardContent
            sx={{
              padding: '0px !important',
              paddingBottom: '0px !important',
              ...fifthCardCss.cardContent
            }}
          >
            <Box sx={{ marginBottom: '32px' }}>
              <Typography
                sx={{
                  padding: '24px 24px 0px 24px',
                  ...BackLinkAllCss?.exploreReferringPagesSx
                }}
              >
                {BackLinkAllTexts?.exploreReferringPages}
              </Typography>
            </Box>
            <Box
              sx={{
                display: { xs: 'grid', tg: 'flex' },
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0px 24px 8px 24px',
                gap: '8px'
              }}
            >
              <Box sx={BackLinkInfoCSS?.filterSubBox}>
                <Box sx={BackLinkInfoCSS?.filterBox}>
                  <Typography sx={BackLinkInfoCSS?.filterTextSx}>
                    {'Link Attribute'}
                  </Typography>
                  <ExpandLess />
                </Box>
                <Box sx={BackLinkInfoCSS?.filterBox}>
                  <Typography sx={BackLinkInfoCSS?.filterTextSx}>
                    {'DA'}
                  </Typography>
                  <ExpandLess />
                </Box>
                <Box sx={BackLinkInfoCSS?.filterBox}>
                  <Typography sx={BackLinkInfoCSS?.filterTextSx}>
                    {'Spam Score'}
                  </Typography>
                  <ExpandLess />
                </Box>
                <Box sx={BackLinkInfoCSS?.filterBox}>
                  <Typography sx={BackLinkInfoCSS?.filterTextSx}>
                    {'Status'}
                  </Typography>
                  <ExpandLess />
                </Box>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  startIcon={
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        '/static/images/icons/upload_icon.svg'
                      }
                      style={{
                        opacity: '1'
                      }}
                    />
                  }
                  sx={{
                    height: '40px',
                    fontWeight: 600,
                    fontSize: 'var(--font-size-14)',
                    padding: '10px 14px',
                    border: '1px solid var(--color-text-muted-purple)',
                    borderRadius: '6px'
                  }}
                  onClick={() => {}}
                >
                  {BackLinkAllTexts?.exportToCSV}
                </Button>
              </Box>
            </Box>
            <Box>
              <TableContainer
                component={Paper}
                square
                style={{
                  marginTop: '15px',
                  boxShadow: 'none',
                  outline: '1px solid rgb(250,250,250)'
                }}
              >
                <Table>
                  {/* Table Head  */}
                  <TableHead>
                    <TableRow sx={KeywordOverviewTableCss?.tableHeaderRow}>
                      {headers?.map((title, i) => {
                        return (
                          <StyledTableCell key={i}>
                            {title !== ' ' && ((i >= 1 && i <= 3) || i == 5) ? (
                              <>
                                <HelpIcon
                                  sx={{
                                    mr: 1,
                                    ...commonTableHeaderIcon?.helpIcon,
                                    ...KeywordOverviewResultCardsCss?.helpIconHead
                                  }}
                                  fontSize="small"
                                />
                                <span style={{ color: 'rgba(0,0,0,0.8)' }}>
                                  {title}
                                </span>
                              </>
                            ) : (
                              <>
                                <HelpIcon
                                  sx={{
                                    mr: 1,
                                    ...commonTableHeaderIcon?.helpIcon,
                                    ...KeywordOverviewResultCardsCss?.helpIconHead
                                  }}
                                  fontSize="small"
                                />
                                <span style={{ color: 'rgba(0,0,0,0.8)' }}>
                                  {title}
                                </span>
                              </>
                            )}
                          </StyledTableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                </Table>
              </TableContainer>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};
